module.exports = __webpack_public_path__ + "static/BtnSteam2-d2ab40cdf5c466c4aadf0e9fa8a4c4c0.png";